import React, { useEffect, useState } from "react";
import SubscriptionAlert from "./banner";
import Organizations from "../../actions/organization";
import { showSubscription } from "../../actions/auth";

export default function SubscriptionBanner() {
  const [alerts, setAlerts] = useState([]);
  const { checkOrganizationSubscription } = Organizations();

  useEffect(() => {
    checkOrganizationSubscription().then((res) => {
      const newAlerts = [];
      if (res.err) {
        newAlerts.push({
          isOpen: true,
          type: "expired",
          message: res.err,
          offset: 10,
        });
      } else if (res?.expired) {
        newAlerts.push({
          isOpen: showSubscription(),
          type: "expired",
          hide: true,
          message: `Your subscription expired on ${new Date(
            res.expiredDate
          ).toDateString()}. Please renew your subscription.`,
          offset: 10,
        });
      } else if (res?.exceeded?.length > 0) {
        const exceededAlerts = res.exceeded.map((item, index) => ({
          isOpen: showSubscription(),
          type: "limit",
          hide: true,
          serviceName: item.serviceName,
          serviceValue: item.serviceValue,
          currentCount: item.currentCount,
          offset: 10 + index * 60,
        }));
        newAlerts.push(...exceededAlerts);
      }

      setAlerts(newAlerts);
    });
  }, []);

  return (
    <>
      {alerts.map((alert, index) => (
        <SubscriptionAlert
          key={index}
          alertInfo={alert}
          setAlertInfo={(updatedAlert) => {
            const newAlerts = [...alerts];
            newAlerts[index] = updatedAlert;
            setAlerts(newAlerts);
          }}
          severity={alert.type === "expired" ? "error" : "error"}
          offset={alert.offset}
        />
      ))}
    </>
  );
}
